/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'

type Props = {
  handleSelectChange?: (data: number) => void
  dataSelect?: any
  text?: any
  defaultValue?: any
}

export const Dropdown1: FC<Props> = ({handleSelectChange, dataSelect, text = 'Năm:', defaultValue}) => {
  const [valueSeleted, setValueSeleted] = useState(defaultValue)

  const OnChangeDropDown = (data: any) => {
    setValueSeleted(data.target.value)
    if (handleSelectChange) handleSelectChange(parseInt(data.target.value))
  }

  return (
    <div className='mb-10'>
      <label className='form-label fw-bold'>{text}</label>
      <div>
        <select
          className='form-select form-select-solid'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          onChange={OnChangeDropDown}
          value={valueSeleted}
        >
          {dataSelect &&
            dataSelect.map((o: any) => (
              <option key={o.value} value={o.value}>
                {o.text}
              </option>
            ))}
        </select>
      </div>
    </div>
  )
}
